<template>
    <div id="navigation" :class="{cogir: $store.state.cogir}">

        <div class="logo">
            <svgicon v-if="!$store.state.cogir" src="svg/logo.svg" :width="140" :height="160"></svgicon>
            <img v-if="$store.state.cogir" src="@/assets/img/logo-cogir-white.png">
        </div>

        <div class="links">
            <router-link :to="{ name: 'home' }" class="link">
                <svgicon src="svg/home.svg" class="icon" :width="30" :height="30"></svgicon>
                {{ $t('menu.home') }}
            </router-link>
            <router-link :to="{ name: 'services' }" class="link">
                <svgicon src="svg/services.svg" class="icon" :width="30" :height="30"></svgicon>
                {{ $t('menu.services') }}
            </router-link>

            <template v-if="User.token">
                <router-link :to="{ name: 'news' }" class="link">
                    <svgicon src="svg/speaker.svg" class="icon" :width="30" :height="30"></svgicon>
                    {{ $t('menu.news') }}
                </router-link>
                <router-link :to="{ name: 'billboard' }" class="link">
                    <svgicon src="svg/news.svg" class="icon" :width="30" :height="30"></svgicon>
                    {{ $t('menu.billboard') }}
                </router-link>
                <router-link :to="{ name: 'requests' }" class="link" v-if="RequestCategories && RequestCategories.categories.length > 0">
                    <svgicon src="svg/history.svg" class="icon" :width="30" :height="30"></svgicon>
                    {{ $t('menu.requests') }}
                </router-link>
                <router-link :to="{ name: 'bookings' }" class="link" v-if="Services && Services.services.length > 0 && Services.categories.length > 0">
                    <svgicon src="svg/date.svg" class="icon" :width="30" :height="30"></svgicon>
                    {{ $t('menu.bookings') }}
                </router-link>
                <router-link :to="{name: 'documents' }" class="link">
                    <svgicon src="svg/folder.svg" :width="30" :height="30" class="icon"></svgicon>
                    {{ $t("menu.documents") }}
                </router-link>
            </template>

            <ExternalLink class="link" :url="urlIshop" v-if="!$store.state.cogir">
                <svgicon src="svg/order.svg" class="icon" :width="30" :height="30"></svgicon>
                {{ $t("menu.order") }}
            </ExternalLink>
            <router-link :to="{ name: 'accountCreation' }" class="link" v-if="!User.token">
                <svgicon src="svg/demande.svg" class="icon" :width="30" :height="30"></svgicon>
                {{ $t("menu.account_request") }}
            </router-link>
            <router-link :to="{ name: 'about' }" class="link">
                <svgicon src="svg/humaniti.svg" class="icon" :width="30" :height="30" v-if="!$store.state.cogir"></svgicon>
                <img src="@/assets/img/icons/octo-white.png" class="icon cogir" v-if="$store.state.cogir" height="30">
                {{ $store.state.cogir ? $t('menu.about_cogir') : $t('menu.about') }}
            </router-link>
        </div>

        <div class="advanced-navigation">
            <router-link :to="link.path"
                         event=""
                         class="advanced-link"
                         v-for="(link, index) in advancedNavigation" :key="index">
                {{link.title}}
            </router-link>
            <div class="copyright">
                &copy; {{ (new Date()).getFullYear() }} {{$store.state.cogir ? 'Cogir' : 'Humaniti'}} <span class="version" v-if="CONFIG.version"> - Version {{CONFIG.version}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import User from "../../../core/User";
    import Services from '../../../core/Services';
    import RequestCategories from '../../../core/RequestCategories';
    import ExternalLink from "../ExternalLink";

    export default {

        name: 'NavigationDesktop',

        components: { ExternalLink },

        data() {
            return {
                User,
                Services,
                CONFIG,
                RequestCategories,
                urlIshop: this.$store.state.cogir ? '' : 'https://web.ishopfood.com/#/humaniti/h3/menu'
            }
        },

        computed: {
            advancedNavigation() {
                return [
                    {
                        title: this.$t("login.terms"),
                        path: "/terms"
                    }, {
                        title: this.$t("login.privacy"),
                        path: "/privacy"
                    }
                ]
            }
        },

        methods: {
            collapse(e) {
                e.target.parentNode.classList.toggle("show");
            }
        }
    }
</script>

<style lang="scss" scoped>

    #navigation {
        background-color: #001722;
        box-shadow: inset 0 0 5px 0 #405159;
        display: flex;
        width: 300px;
        flex-direction: column;
        overflow: hidden;
        flex-shrink: 0;
    }

    #navigation.cogir {
        background-color: #1a1a1a;
        box-shadow: inset 0 0 5px 0 rgb(65, 65, 65);

        .link {
            color: #808080;
            &:hover {
                border-left-color: #94c11f;
            }
            &.router-link-active {
                border-left-color: #94c11f;
                color: white;
                .svgicon {
                    fill: #bfbfbf;
                }
            }
        }
        .svgicon {
            fill: #404040;
        }
        .logo {
            height: 160px;
            padding: 20px;
        }
    }

    .links {
        display: flex;
        flex-direction: column;
        overflow: auto;

        &::-webkit-scrollbar {
            width: 10px;
        }
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        &::-webkit-scrollbar-thumb {
            background: #405159;
            border-radius: 4px;
        }
    }

    .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        .svgicon {
            fill: white;
        }
        img {
            max-width: 100%;
        }
    }

    .link {
        border-bottom: 1px solid rgba(255,255,255,0.05);
        border-left: 10px solid  rgba(255,255,255,0.05);
        padding: 25px 10px 25px 25px;
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: border 300ms ease-in-out;
        flex-shrink: 0;
        color: #808b91;
        cursor: pointer;

        &:hover {
            border-left: 10px solid #405159;
        }
        &.router-link-active {
            border-left: 10px solid #405159;
            color: #fff;
            .svgicon {
                fill: #808b91;
            }
            .icon.cogir {
                opacity: 0.75;
            }
        }
        .title {
            flex-grow: 1;
        }
    }
    .icon {
        margin-right: 30px;
        &.cogir {
            opacity: 0.25;
        }
    }
    .svgicon {
        fill: #405159;
    }
    .advanced-navigation {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 25px;
        flex-grow: 1;
        flex-shrink: 0;
    }
    .advanced-link, .copyright {
        color: #808b91;
        text-decoration: none;
        margin-top: 4px;
        transition: color 250ms ease-in-out;
        font-size: 14px;
    }
    .advanced-link:hover {
        color: white;
    }
    .cogir .advanced-link:hover {
        color: #94c11f;
    }

    .requests {
        list-style: none;
        border-bottom: 1px solid #405159;
        margin: 0;
        padding: 30px 0 20px 40px;
        .request {
            display: flex;
            height: 30px;
            .value {
                color: #bfc5c8;
                font-weight: 500;
            }
            .name {
                padding: 0 12px;
                color: #808b91;
            }
            .ico-alert {
                display: none;
            }
            .ico-alert.active {
                display: block;
            }
        }
    }

    .collapsible-container {
        flex-direction: column;
        border-bottom: 1px solid #0d232d;
        border-left: 10px solid #0d232d;

        &:hover {
             border-left: 10px solid #405159;
        }

        .link {
            border-bottom: 0;
            border-left: 0;
        }

        &.show {
            .collapsible {
                display: block;
            }
            .collapsible-icon {
                transform: rotateZ(-180deg);
            }
        }
    }
    .collapsible-icon {
        margin-left: auto;
        pointer-events: none;
        color: #405159;
    }
    .dot {
        width: 10px;
        height: 10px;
        flex-shrink: 0;
        background-color: #405159;
        border-radius: 10px;
        margin-right: 40px;
        margin-left: 10px;
    }
    .sub-link {
        border-bottom: none;
        min-height: 40px;
        padding: 10px 30px;
        display: flex;
        align-items: center;
        text-decoration: none;
        color: #808b91;

        &.router-link-active {
            border-left: 10px solid var(--secondary-color);
            margin-left: -10px;
            color: #fff;
            .dot {
                background-color: #808b91;
            }
        }

        &:last-child {
            padding-bottom: 20px;
        }
    }
    .collapsible {
        display: none;
    }

    .version {
        opacity: 0.6;
    }

</style>
